import React from 'react';

const OutlookEnvelope: React.FC = () => {
  // No animation delay needed for infinite loop
  const animationDelay = 0;
  return (
    <div id="loadingLogo" dir="ltr" style={{ display: 'flex', justifyContent: 'center' }}>
      <style>
        {`
          #loadingLogo {
            --s: 180px;
            --envW: 130px;
            --envH: 71px;
            --calW: 118px;
            --sqW: calc(var(--calW) / 3);
            --sqH: 37px;
            --calHH: 20px;
            --calH: calc(var(--sqH) * 3 + var(--calHH));
            --calY: calc(var(--calH) + 20px);
            --calYExt: calc(var(--calH) - 80px);
            --calYOverExt: calc(var(--calH) - 92px);
            --flapS: 96px;
            --flapH: calc(0.55 * var(--envH));
            --flapScaleY: calc(var(--flapH) / var(--flapWidth));
            --dur: 5s;
          }

          #container {
            width: var(--s);
            height: var(--s);
            animation: bounce var(--dur) infinite;
            animation-fill-mode: forwards;
            animation-delay: ${animationDelay}ms;
            margin: 0 auto;
          }

          @keyframes bounce {
            0%,100%,12.5%,32.5%,76.1% {
              transform: translateY(0);
            }
            22.5%,86% {
              transform: translateY(7px);
            }
          }

          #logo {
            height: 179px;
            width: 130px;
            overflow: hidden;
            margin-top: -59px;
            margin: -59px auto 0 auto;
          }

          #containerShadow {
            position: relative;
            top: 120px;
            left: 50%;
            transform: translateX(-50%);
            width: var(--envW);
            height: var(--envH);
            border-radius: 0 0 7px 7px;
            box-shadow: rgba(0,0,0,.25) 0 4px 5px;
            animation: shadow-fade var(--dur) infinite;
            animation-fill-mode: forwards;
            animation-delay: ${animationDelay}ms;
          }

          @keyframes shadow-fade {
            0%,100%,21.2%,80% {
              opacity: 0;
            }
            47%,70% {
              opacity: 1;
            }
          }

          #flapContainer {
            width: var(--envW);
            margin-top: 179px;
          }

          #ef {
            width: var(--envW);
            height: var(--envH);
            border-radius: 0 0 7px 7px;
            overflow: hidden;
            margin-top: -41px;
          }

          #ef>.l {
            width: 287px;
            height: var(--envH);
            background: #3B82F6;
            transform: translate(-153px,-70px) rotate(28deg);
          }

          #ef>.r {
            width: 287px;
            height: var(--envH);
            background: #2563EB;
            transform: translate(-120px,63px) rotate(-28deg);
          }

          #eb {
            width: var(--envW);
            height: 40px;
            background: #0055FF;
            margin-top: -70px;
          }

          #cal {
            display: flex;
            flex-direction: column;
            width: var(--calW);
            height: var(--calH);
            border-radius: 7px;
            overflow: hidden;
            margin: 0 auto;
            margin-top: -306px;
            animation: cal-bounce var(--dur) infinite;
            animation-timing-function: cubic-bezier(0,0.5,0,1);
            animation-fill-mode: forwards;
            animation-delay: ${animationDelay}ms;
            transform: translateY(var(--calYExt)) scaleY(1);
            padding: 8px;
            box-sizing: border-box;
            background: #ffffff;
            border: 1px solid #e5e7eb;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          }

          @keyframes cal-bounce {
            0%,100%,16.5%,76.1% {
              transform: translateY(var(--calY)) scaleY(1);
            }
            28% {
              transform: translateY(var(--calYOverExt)) scaleY(1);
            }
            31% {
              transform: translateY(var(--calYExt)) scaleY(1.05);
            }
            33% {
              transform: translateY(var(--calYExt)) scaleY(.96);
            }
            34%,68.5% {
              transform: translateY(var(--calYExt)) scaleY(1);
            }
            68.5% {
              animation-timing-function: cubic-bezier(0.66,-0.16,1,-0.29);
            }
          }

          /* Grouped Lines Styles */
          .group-header {
            width: 100%;
            height: 14px;
            background: #1E40AF;
            margin-bottom: 6px;
            border-radius: 2px;
          }

          .group-line {
            width: 100%;
            height: 6px;
            margin-bottom: 2px;
            border-radius: 1px;
          }

          .group-spacer {
            height: 8px;
            width: 100%;
          }

          .group-line-1 {
            background: #2563EB;
          }

          .group-line-2 {
            background: #3B82F6;
          }

          .group-line-3 {
            background: #60A5FA;
          }

          .group-line-4 {
            background: #2563EB;
          }

          .group-line-5 {
            background: #3B82F6;
          }

          .group-line-6 {
            background: #60A5FA;
          }

          .group-line-7 {
            background: #2563EB;
          }

          .group-line-8 {
            background: #3B82F6;
          }

          .group-line-9 {
            background: #60A5FA;
          }

          .group-line-10 {
            background: #2563EB;
          }

          .group-line-11 {
            background: #3B82F6;
          }

          #openedFlap {
            width: var(--envW);
            height: 107px;
            animation: opened-flap-swing var(--dur) infinite;
            animation-timing-function: cubic-bezier(0.32,0,0.67,0);
            animation-fill-mode: forwards;
            animation-delay: ${animationDelay}ms;
            transform-origin: top;
            transform: translateY(-68px) rotate3d(1,0,0,-180deg);
          }

          @keyframes opened-flap-swing {
            0%,100%,14.5%,76% {
              transform: translateY(-68px) rotate3d(1,0,0,-90deg);
            }
            16.5%,74% {
              transform: translateY(-68px) rotate3d(1,0,0,-180deg);
            }
          }

          #closedFlap {
            width: var(--envW);
            animation: closed-flap-swing var(--dur) infinite;
            animation-timing-function: cubic-bezier(0.32,0,0.67,0);
            animation-fill-mode: forwards;
            animation-delay: ${animationDelay}ms;
            transform-origin: top;
            transform: translateY(calc(-1 * var(--envH))) rotate3d(1,0,0,90deg);
          }

          @keyframes closed-flap-swing {
            0%,100%,77%,8.5% {
              transform: translateY(calc(-1 * var(--envH))) rotate3d(1,0,0,0);
            }
            14.5%,76% {
              transform: translateY(calc(-1 * var(--envH))) rotate3d(1,0,0,90deg);
            }
          }

          #fmask {
            width: var(--envW);
            height: 107px;
            overflow: hidden;
          }

          .flapTriangle {
            width: var(--flapS);
            height: var(--flapS);
            background: #60A5FA;
            margin: -48px auto 0 auto;
            border-radius: 7px;
            transform: scaleY(.6) rotate(45deg);
          }

          #openedFlap .flapTriangle {
            background: #0055FF;
          }

          #closedFlap .flapTriangle {
            background: #60A5FA;
          }
        `}
      </style>
      <div id="container">
        <div id="containerShadow"></div>
        <div id="logo">
          <div id="flapContainer">
            <div id="openedFlap">
              <div id="fmask">
                <div className="flapTriangle"></div>
              </div>
            </div>
            <div id="cal">
              <div className="group-header"></div>
              <div className="group-line group-line-1"></div>
              <div className="group-line group-line-2"></div>
              <div className="group-line group-line-3"></div>
              <div className="group-spacer"></div>
              <div className="group-line group-line-4"></div>
              <div className="group-line group-line-5"></div>
              <div className="group-line group-line-6"></div>
              <div className="group-spacer"></div>
              <div className="group-line group-line-7"></div>
              <div className="group-line group-line-8"></div>
              <div className="group-line group-line-9"></div>
              <div className="group-spacer"></div>
              <div className="group-line group-line-10"></div>
              <div className="group-line group-line-11"></div>
            </div>
          </div>
          <div id="eb"></div>
          <div id="ef">
            <div className="r"></div>
            <div className="l"></div>
          </div>
          <div id="closedFlap">
            <div id="fmask">
              <div className="flapTriangle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutlookEnvelope;